<template>
	<c-dialog ref="dialog" title="装配工单详情" mode="slide" width="100vw-300" enable-flex mask-close :button="false">
		<template #head>
			<div v-if="detailData.order_code" class="m-detail-tag flex-center-cross">
				<label>{{detailData.order_code}}</label>
				<c-state dict="orderStateDic" tag :value="detailData.order_state"></c-state>
			</div>
		</template>
		
		<module>
			<module-col size="350">
				<c-detail class="m-detail-form">
					<c-detail-item label="装配二维码">
						<c-qrcode :value="detailData.h5_web" size="100"></c-qrcode>
					</c-detail-item>
					<c-detail-item label="生产进度">
						<c-progress :rate="[detailData.ok_count, detailData.plan_count]" :color="((detailData.ok_count/detailData.plan_count)>=1||detailData.plan_count==0) ?'green':'blue'"></c-progress>
					</c-detail-item>
					<c-detail-item label="单据进度">
						<c-progress :rate="[detailData.work_end_count, detailData.work_all_count]" :color="((detailData.work_end_count/detailData.work_all_count)>=1||detailData.work_all_count==0) ?'green':'blue'"></c-progress>
					</c-detail-item>
					<c-detail-item label="计划数">
						<b>{{detailData.plan_count}}</b>
					</c-detail-item>
					<c-detail-item label="完工数">
						<b>{{detailData.ok_count}}</b>
					</c-detail-item>
					<c-detail-item label="工单数">
						{{detailData.work_all_count}}
					</c-detail-item>
					<c-detail-item label="已结束工单数">
						{{detailData.work_end_count}}
					</c-detail-item>
					<c-detail-item label="创建人">
						{{detailData.create_user_realname}}
					</c-detail-item>
					<c-detail-item label="创建时间">
						{{detailData.create_date}}
					</c-detail-item>
					<c-detail-item v-if="detailData.ref_code" label="关联单据">
						<order-link :type="detailData.ref_type" :id="detailData.ref_id" :code="detailData.ref_code"></order-link>
					</c-detail-item>
					<custom-detail work-type="34" :data="detailData.customFieldValues"></custom-detail>
				</c-detail>
			</module-col>

			<module-col tab-type="border-tab">
				<module-tab name="产品明细" enable-flex>
					<div class="m-detail-box">
						<custom-table ref="productTable" view-id="20011" height="grow" readonly>
							<c-table-column
								type="tree"
								label="BOM层级"
								width="300"
								name="childProduct"
								level-limit="5"
								:leaf-node="({data}) => !data.childProduct"
							>
								<template #default="{data}">
									{{data.product_name}}
								</template>
							</c-table-column>

							<!--产品来源-->
							<template #product_source="{data}">
								<c-state dict="productSourceName" :value="data.product_source"></c-state>
							</template>

							<template #product_type="{data}">
								<c-state dict="productTypeName" :value="data.product_type"></c-state>
							</template>
								
							<!--工单进度-->
							<template #process_rate="{data}">
								<process-rate v-if="data.id" :key="data._timestamp" :id="data.id"></process-rate>
								<span v-else>-</span>
							</template>
							
							<!--工单进度%-->
							<template #work_progress="{data}">
								<c-progress :rate="[data.ok_count, data.plan_count]" :color="((data.ok_count/data.plan_count)>=1||data.plan_count==0) ?'green':'blue'"></c-progress>
							</template>
							
							<!--工单明细进度%-->
							<template #work_detail_progress="{data}">
								<c-progress :rate="[data.task_fine_count, data.task_plan_count||1]" :color="((data.task_fine_count/data.task_plan_count)>=1||data.task_plan_count==0) ?'green':'blue'"></c-progress>
							</template>
							
							<!--工单状态-->
							<template #work_state="{data}">
								<c-state v-if="data.id" dict="orderStateDic" :value="data.work_state"></c-state>
								<span v-else>-</span>
							</template>
							
							<!--优先级-->
							<template #priority="{data}">
								<c-state dict="priorityDic" tag :value="data.priority"></c-state>
							</template>
								
							<!--计划开始/结束时间-->
							<template #plan_date="{data}">
								{{data.plan_start_date}} - {{data.plan_end_date}}
							</template>
							
						</custom-table>
					</div>
				</module-tab>
			</module-col>
		</module>
	</c-dialog>
</template>

<script>
	export default {
		name: 'assembleDetail',

		props: {
			id: [String, Number]
		},
		
		data() {
			return {
				detailData: {}
			}
		},

		methods: {
			open() {
				this.request({
					url: '/assemble/detail',
					data: {
						id: this.id
					},
					loading: true,
					success: data => {
						this.detailData = data.detailInfo;
						this.$refs.productTable.init();
						this.$refs.productTable.$refs.list.setData(data.productList);
						this.$refs.dialog.open();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>